// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Database
import { getAuth } from "firebase/auth";           
import { getStorage } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";

// Your web app's Firebase configuration
// IMPORTANT: Create a .env.local file with your Firebase credentials
// See .env.example for the required environment variables
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
const functions = getFunctions(app);

// Export the services so App.jsx can use them
export const db = getFirestore(app);
export const auth = getAuth(app);    // <--- THIS IS THE MISSING EXPORT
export const storage = getStorage(app); // <--- EXPORT THIS

// Export callable functions for AI features (API key stays secure on server)
export const scanBillFunction = httpsCallable(functions, 'scanBill');
export const analyzeUtilityUsageFunction = httpsCallable(functions, 'analyzeUtilityUsage');

// Export callable functions for server-side data queries
export const getMonthlyStatsFunction = httpsCallable(functions, 'getMonthlyStats');
export const searchArchivedBillsFunction = httpsCallable(functions, 'searchArchivedBills');
export const applyAutoCorrectionsFunction = httpsCallable(functions, 'applyAutoCorrections');
export const runDuplicateAuditFunction = httpsCallable(functions, 'runDuplicateAudit');
export const exportBillDataFunction = httpsCallable(functions, 'exportBillData');
export const getAnalysisDataFunction = httpsCallable(functions, 'getAnalysisData');
export const scanForCorrectionsFunction = httpsCallable(functions, 'scanForCorrections');
export const rebuildAllSiteNamesFunction = httpsCallable(functions, 'rebuildAllSiteNames');
export const removeFacilityFunction = httpsCallable(functions, 'removeFacility');
export const getEnterpriseAnalyticsDataFunction = httpsCallable(functions, 'getEnterpriseAnalyticsData');
export const saveReductionTargetsFunction = httpsCallable(functions, 'saveReductionTargets');
export const getReductionTargetsFunction = httpsCallable(functions, 'getReductionTargets');
export const queryEnterpriseDataFunction = httpsCallable(functions, 'queryEnterpriseData');